import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IGroupAlertBehavior } from "../../../../documaker/domain/format/objects";

export interface IGroupAlertBehaviorPropertyEditable {
  groupAlertBehavior(): IPropertyEditable<IGroupAlertBehavior>;
}

export function instanceOfIGroupAlertBehaviorPropertyEditable(instance: any): instance is IGroupAlertBehaviorPropertyEditable {
  return instance
      && instance.groupAlertBehavior
      && instanceOfIPropertyEditable<IGroupAlertBehavior>(instance.groupAlertBehavior());
}
